"use client";

import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Box, Button, List, ListItem, ListItemText, Typography } from "@mui/material";
import { useState } from "react";

type Props = {
  features: string[];
  alwaysExpanded?: boolean;
};

const PREVIEW_COUNT = 3;

export default function ProductFeaturesView({ features, alwaysExpanded = false }: Props) {
  const [expanded, setExpanded] = useState(false);
  const showAll = alwaysExpanded || expanded;
  const canToggle = !alwaysExpanded && features.length > PREVIEW_COUNT;

  return (
    <Box>
      <List dense disablePadding>
        {features.map((str, index) => {
          const hidden = canToggle && !showAll && index >= PREVIEW_COUNT;
          return (
            <ListItem
              key={index}
              sx={{
                display: hidden ? "none" : "flex",
                alignItems: "flex-start",
                py: 0.4,
                px: 0,
                gap: 1,
              }}
            >
              <Box
                aria-hidden
                sx={{
                  width: 6,
                  height: 6,
                  mt: "0.55em",
                  borderRadius: "50%",
                  bgcolor: "secondary.main",
                  flexShrink: 0,
                }}
              />
              <ListItemText sx={{ m: 0 }} primary={<Typography variant="body2" sx={{ lineHeight: 1.8 }}>{str}</Typography>} />
            </ListItem>
          );
        })}
      </List>
      {canToggle && (
        <Button
          variant="text"
          size="small"
          onClick={() => setExpanded((open) => !open)}
          endIcon={showAll ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          sx={{ mt: 0.5, px: 0.5 }}
        >
          {showAll ? "نمایش کمتر" : "ویژگی‌های بیشتر"}
        </Button>
      )}
    </Box>
  );
}
